import { Component } from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

class SupportPopup extends Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
    this.clickHandler = this.clickHandler.bind(this)
    this.handleEscape = this.handleEscape.bind(this)
  }

  componentDidMount() {
    window.addEventListener('click', this.clickHandler)
    window.addEventListener('keydown', this.handleEscape)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickHandler)
    window.removeEventListener('keydown', this.handleEscape)
  }

  handleEscape(e) {
    e = e || window.event
    if (e.keyCode === 27) {
      this.handleClose()
    }
  }

  clickHandler(e) {
    const className = $(e.target).attr('class')
    if (className && className.trim() === 'modal') {
      this.handleClose()
    }
  }

  handleClose() {
    this.props.cancelCallback()
  }

  render() {
    const { isOpen, className } = this.props
    return (
      <div className={`modal modal--support ${isOpen ? 'is-active' : ''} ${className || ''}`}>
        <div className="modal-background" />
        <div className="modal-content">
          <div className="box">
            <header className="modal__header">
              <span>Support</span>
              <button
                className="modal-close is-large"
                aria-label="close"
                onClick={this.handleClose}
              />
            </header>
            <div className="modal__inner">
              <div className="modal__body">
                <div style={{ marginBottom: '-15px' }}>Our service hours are:</div>
                {`
                Mon-Fri: 8AM - 8PM CST
                Sat: 8AM - 8PM CST (e-mail only)
                Sun: 8AM - 8PM CST (e-mail only)
                
                `}

                <div>Please e-mail us for fastest response:</div>
                <div>
                  <a href={'mailto:' + 'techsupport@elevatedliving.com'}>
                    techsupport@elevatedliving.com
                  </a>
                </div>
                <br />
                <div>Number:</div>
                <div>
                  <a href={'tel:' + '+13216008628'}>+1 321-600-8628</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

SupportPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  cancelCallback: PropTypes.func,
  className: PropTypes.string,
}

SupportPopup.defaultProps = {
  className: '',
}

export default SupportPopup
